import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
    getIeHeatmap,
    sortIeHeatmap,
    getEmpExpResurveyHeatmapData,
    getDemographics,
    getBenchmarks,
    updateHeatMapInfo,
    getMappedDemographics,
    getEmpExpResurveyData,
    resetEmpExpResDataFetched,
    updateFilters,
    getExBenchmarks,
    getComparisonYearSettings,
    getCompType,
} from '../../actions';

import {
    selectApiCount,
    selectApiParams,
    selectCompYrSettings,
    selectEmpExpResurveyData,
    selectEmpExpResurveyDatFetched,
    selectFilters,
    selectFootnoteList,
    selectProjects,
    selectProjectsFetched,
    selectSingleQuestion,
    selectCompType,
    selectCompTypeFetched,
} from '../../selector';

import QuestionsBoard from './QuestionsBoard';
import { getDefaultSettings } from '../../../Login/selector';

const stateToProps = createStructuredSelector({
    apiLoadingCount: selectApiCount(),
    defaultSettings: getDefaultSettings(),
    apiParams: selectApiParams(),
    projects: selectProjects(),
    singleQuestion: selectSingleQuestion(),
    empExpResurveyData: selectEmpExpResurveyData(),
    empExpResurveyDataFetched: selectEmpExpResurveyDatFetched(),
    projectsFetched: selectProjectsFetched(),
    filters: selectFilters(),
    footnoteList: selectFootnoteList(),
    compYrSettings: selectCompYrSettings(),
    compType: selectCompType(),
    compTypeFetched: selectCompTypeFetched(),
});

const dispatchToProps = {
    getIeHeatmap,
    sortIeHeatmap,
    getEmpExpResurveyHeatmapData,
    // resetReSurveyDataFetched,
    getDemographics,
    getBenchmarks,
    updateHeatMapInfo,
    getMappedDemographics,
    getEmpExpResurveyData,
    resetEmpExpResDataFetched,
    updateFilters,
    getExBenchmarks,
    getComparisonYearSettings,
    getCompType,
};

export default connect(stateToProps, dispatchToProps)(QuestionsBoard);
